var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "semipolar-spinner", style: _vm.spinnerStyle },
    _vm._l(_vm.ringsStyles, function(rs, index) {
      return _c("div", { key: index, staticClass: "ring", style: rs })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }